module.exports = __webpack_public_path__ + "d1659042221b84ac8a334872d971cfbd.png";